
import {Observable, ReplaySubject, Subject, Subscription} from 'rxjs';
import {Injectable, OnDestroy} from "@angular/core";
import {ShortcutsConfigProxy} from "./shortcuts.config.proxy";
import {HttpObservable} from "../../http/services";
import {ShortcutsData, ShortcutsUpdateRequest} from "../interfaces/shortcuts.data";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {tap} from "rxjs/operators";

@UntilDestroy()
@Injectable({ providedIn: 'root' })
  export class ShortcutsConfigService implements OnDestroy {
	private shortcutsData: ShortcutsData;
	private shortcutsSubj: ReplaySubject<ShortcutsData> = new ReplaySubject<ShortcutsData>(1);

	private loadShortcutsSubscription: Subscription;

	constructor(private shortcutsConfigProxy: ShortcutsConfigProxy) {
	}

	public loadShortcuts(forceLoad: boolean = false) : Observable<ShortcutsData> {
		if (forceLoad || !this.shortcutsData) {
			this.loadShortcutsSubscription?.unsubscribe();
			this.loadShortcutsSubscription = this.getShortcuts()
				.pipe(untilDestroyed(this))
				.subscribe(res => {
					this.shortcutsData = res;
					this.shortcutsSubj.next(res);
				});
		}

		return this.shortcutsSubj.asObservable();
	}

	public ngOnDestroy(): void {
		this.loadShortcutsSubscription?.unsubscribe();
	}

	public getShortcuts(): HttpObservable<ShortcutsData> {
		return this.shortcutsConfigProxy.getShortcuts();
	}

	public updateShortcuts(shortcuts: ShortcutsUpdateRequest): HttpObservable<any> {
		return this.shortcutsConfigProxy.updateShortcuts(shortcuts).pipe(untilDestroyed(this),
			tap(() => this.loadShortcuts(true)));
	}
}
